<!-- TODO - DELETE AND CHANGE THIS MODAL -->
<div id="modalGeneral" class="modal fade-modal in-modal">
  <div class="modal-dialog modal-sm succes-modal">
    <div class="modal-content">
      <div class="modal-body text-center p-16">
        <div class="succes-modal__title-modal text-center p-b-8">
          <h5 class="f12 upper m-0" [ngClass]="class"><strong>{{ tit | translate }}</strong></h5>
        </div>

        <p *ngIf="opt !== 4 && opt !== 7 && opt !== 8 && opt !== 11 && opt !== 18" class="text-center f13 m-b-30">{{ msg | translate }}</p>
        <p *ngIf="opt === 4 || opt === 7 || opt === 8 || opt === 11 || opt === 18" class="text-center f13 m-b-30"><span *ngFor="let items of msg">{{ items | translate }}</span></p>

        <div class="flex align-items-center justify-content-around btns-footer">
          <base-button
            *ngIf="!bot2"
            buttonClass="min-w-150px"
            color="secondary"
            height="tall"
            width="auto"
            [text]="'actions.close' | translate"
            [type]="(!bot2 && !bot ? 'submit' : 'button')"
            (onClick)="close()">
          </base-button>
          <base-button
            *ngIf="bot"
            buttonClass="min-w-150px"
            height="tall"
            type="submit"
            width="auto"
            [text]="'actions.continue' | translate"
            (onClick)="closeS()">
          </base-button>
          <base-button
            *ngIf="bot2"
            buttonClass="min-w-150px"
            height="tall"
            type="submit"
            width="auto"
            [text]="'actions.understood' | translate"
            (onClick)="closeUnd()">
          </base-button>
        </div>
      </div>
    </div>
  </div>
</div>
